import { render, staticRenderFns } from "./CorrelationFailed.vue?vue&type=template&id=42ff1bf3&scoped=true"
import script from "./CorrelationFailed.vue?vue&type=script&lang=js"
export * from "./CorrelationFailed.vue?vue&type=script&lang=js"
import style0 from "./CorrelationFailed.vue?vue&type=style&index=0&id=42ff1bf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff1bf3",
  null
  
)

/* custom blocks */
import block0 from "./CorrelationFailed.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports